import { oktaAuth } from '../config/okta'

// Setup automatic token refresh
export function setupOktaInterceptor() {
  oktaAuth.tokenManager.on('error', function (err) {
    console.error('Token error:', err)
    // Handle token errors (e.g., redirect to login)
    if (err.name === 'AuthApiError' || err.name === 'OAuthError') {
      oktaAuth.signOut()
    }
  })

  // Start the token manager
  oktaAuth.start()
}
